module.exports = __webpack_public_path__ + "static/img/bgSupport.6ddd75a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgSupport.jpg
// module id = qG+b
// module chunks = 13